import { Injectable, signal, computed } from '@angular/core';

export type Theme = 'light' | 'dark';

/**
 * WizTasks is dark-mode only. This service keeps its original API (theme,
 * isDark, setTheme, toggle, init) so every existing call site keeps working
 * unchanged, but it now always resolves to 'dark' — setTheme()/toggle() are
 * no-ops. Kept as a service (rather than inlining a static "dark" class on
 * <html>) so light mode can be reintroduced later without touching callers.
 */
@Injectable({ providedIn: 'root' })
export class ThemeService {
  private themeSignal = signal<Theme>('dark');
  theme = this.themeSignal.asReadonly();
  isDark = computed(() => true);

  setTheme(_theme: Theme): void {
    // No-op: dark mode only.
  }

  toggle(): void {
    // No-op: dark mode only.
  }

  init(): void {
    if (typeof window === 'undefined') return;
    document.documentElement.classList.add('dark');
  }
}
